// extracted by css-extract-rspack-plugin
export default {"item":"item-eP697A flex gap-base items-center","icon":"icon-nvuRcz","content":"content-c4LRkU"};